import React from 'react';

import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { createAgentTag } from 'api/agents';
import { getTags } from 'api/tags';
import { useParams } from 'react-router-dom';
import Popup from 'components/Popup';
import SelectInput from 'components/Form/SelectInput';
import Button from 'components/Button';

export default function AgentAddTagPopup({
    visible,
    setVisible,
    present = [],
}) {

    const { agentId } = useParams();
    const cache = useQueryClient();

    const { mutate: update } = useMutation({
        mutationKey: ['updateOffice'],
        mutationFn: createAgentTag,
        onSuccess: () => {
            cache.invalidateQueries(['agents', agentId]);
            return setVisible(false);
        },
        onError: (error) => {
            console.error("Error updating agent-tag:", error);
        }
    });

    const { data: elements } = useQuery({
        queryKey: ['tags'],
        queryFn: async () => await getTags({}),
    });


    const selectOptions = elements?.map(element => {
        return {
            value: element._id,
            label: element.name
        }
    });


    function onSubmitHandler(e) {
        e.preventDefault();
        return update({
            id: agentId,
            data: {
                tag: e.target.tag.value
            }
        });
    }

    return (
        <Popup
            visible={visible}
            setVisible={setVisible}
        >
            <form onSubmit={onSubmitHandler}>
                {selectOptions &&
                    <SelectInput
                        label="Tag"
                        name="tag"
                        options={selectOptions?.filter(element => !present.includes(element.value))}
                        required
                    />
                }

                <div className='flex justify-between gap-4 mt-6'>
                    <div onClick={() => setVisible(false)} className='hover:bg-verylight cursor-pointer px-4 py-3 text-sm rounded-sm'>
                        Annulla
                    </div>
                    <Button submit>Conferma</Button>
                </div>
            </form>
        </Popup>
    )
}
